import { AppState } from '../../../store/state';
import { UiState } from '../../../store/ui/state';
import { Component, HostBinding, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AdminType } from 'src/app/enum/question-enum';
import { ConfirmationDialogComponent } from 'src/app/pages/confirmation-dialog/confirmation-dialog.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common/common.service';

const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
  @HostBinding('class') classes: string = BASE_CLASSES;
  enum: typeof AdminType = AdminType;
  public ui!: Observable<UiState>;
  public menu;
  adminRoleId!:number;
  constructor(
    private store: Store<AppState>,
    private modalService: NgbModal,
    public commonService: CommonService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.ui = this.store.select((state: AppState) => state.ui);
    this.ui.subscribe((state: UiState) => {
      this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
    });
    this.adminRoleId = this.authService.getAdminRoleId();
    switch (this.adminRoleId) {
      case this.enum.SuperAdmin:
        this.menu = SUPERADMIN_MENU;
        break;
      case this.enum.CompanyAdmin:
        this.menu = COMPANYADMIN_MENU;
        break;
      case this.enum.Admin:
        this.menu = SUPERADMIN_MENU;
        break;
      case this.enum.HR:
        this.menu = SUPERADMIN_MENU;
        break;
      case this.enum.Receptionist:
        this.menu = SUPERADMIN_MENU;
        break;
      default:
        this.menu = SUPERADMIN_MENU;
        break;
    }
  }
  handleMenuItemClick(item: any) {
    if (item.name === 'Logout') {
      const modalRef = this.modalService.open(ConfirmationDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.result.then((result) => {
        if (result === 'logout') {
        this.authService.logout();
        }
      }).catch(() => {});
    }
  }
}

export const COMPANYADMIN_MENU = [
  {
    name: 'Student',
    Image: '../../../../assets/img/student-list-icon.svg',
    path: ['/student']
  },
  {
    name: 'College Batch',
    Image: '../../../../assets/img/clg-batch-icon.svg',
    path: ['/college-batch']
  },
  {
    name: 'Question Set',
    Image: '../../../../assets/img/Question-Set-icon.svg',
    path: ['/question-set']
  },
  {
    name: 'Questions',
    Image: '../../../../assets/img/que-set-icon.svg',
    path: ['/question']
  },
  {
    name: 'Exam',
    Image: '../../../../assets/img/test.svg',
    path: ['/exam']
  },
  {
    name: 'Job',
    Image: '../../../../assets/img/Job.svg',
    path: ['/job']
  },
  {
    name: 'Company profile',
    Image: '../../../../assets/img/company.svg',
    path: ['/company-profile']
  },
  {
    name: 'Logout',
    Image: '../../../../assets/img/logout-icn.svg',
    click: 'handleMenuItemClick'
  }  
]; 

export const SUPERADMIN_MENU = [
  {
    name: 'User Management',
    Image: '../../../../assets/img/user-icon.svg',
    path: ['/user']
  },
  {
    name: 'Company',
    Image: '../../../../assets/img/company.svg',
    children: [
      {
        name: 'Company',
        Image: '../../../../assets/img/company.svg',
        path: ['/company']
      },
      {
        name: 'Company User',
        Image: '../../../../assets/img/user-icon.svg',
        path: ['/company-user']
      }
    ]
  },
  {
    name: 'College',
    Image: '../../../../assets/img/clg-list-icon.svg',
    path: ['/college']
  },
  {
    name: 'Technology Preference',
    Image: '../../../../assets/img/TechnologyPreference.png',
    children: [
      {
        name: 'Parent Technology',
        Image: '../../../../assets/img/Polygon.png',
        path: ['/Parent-technology-preference']
      },
      {
        name: 'Child Technology',
        Image: '../../../../assets/img/Polygon.png',
        path: ['/Child-technology-preference']
      }
    ]
  },
  {
    name: 'Report Problem',
    Image: '../../../../assets/img/report-problem-icon.svg',
    path: ['/report-problem']
  },
  {
    name: 'Logout',
    Image: '../../../../assets/img/logout-icn.svg',
    click: 'handleMenuItemClick'
  }
];